import { TextProps } from '@chakra-ui/react';
import React from 'react';

import { CmText } from './CmText';

export const CmHelpterText: React.FC<TextProps> = ({ children, ...rest }) => {
  return (
    <CmText fontSize="xs" color="#696969" {...rest}>
      {children}
    </CmText>
  );
};
